// © 2025 nSide, Inc. All Rights Reserved.
// This software and its source code are the confidential and proprietary
// information of nSide, Inc. (“Confidential Information”). You may not
// use, reproduce, disclose, distribute, modify, or create derivative works
// of this code except in accordance with a written license agreement or
// other written authorization from nSide, Inc.

// Unauthorized use is strictly prohibited and may result in civil and
// criminal penalties.



import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>'
})

export class AppComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    if (window.top === window.self) {
      // Not in an iframe, redirect to error page
      this.router.navigate(['/error'], { queryParams: { message: 'Access Denied. Cannot access' } });
    }
  }
}